/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { combineReducers } from "redux";

import { authReducer } from "~/features/auth/slice";
import { dashboardReducer } from "~/features/dashboard/slice";
import { featureFlagReducer } from "~/features/featureFlag/slice";
import { forgotPasswordReducer } from "~/features/forgotPassword/slice";
import { headerReducer } from "~/features/header/slice";
import { messagesReducer } from "~/features/messages/slice";
import { myAccountReducer } from "~/features/myAccount/slice";
import { mySitesReducer } from "~/features/mySites/slice";
import { NewsReducer } from "~/features/news/slice";
import { oneClickReducer } from "~/features/oneClick/slice";
import { promoToolsReducer } from "~/features/promoTools/slice";
import { reportTrackerReducer } from "~/features/reportTracker/slice";
import { setPasswordReducer } from "~/features/setPassword/slice";
import { signupReducer } from "~/features/signup/slice";
import { sitebuilderReducer } from "~/features/sitebuilder/slice";
import { statisticsReducer } from "~/features/statistics/slice";
import { unsavedChangesReducer } from "~/features/unsavedChanges/slice";
import { userGuideReducer } from "~/features/userGuide/slice";

const rootReducer = combineReducers({
  auth: authReducer,
  userGuide: userGuideReducer,
  dashboard: dashboardReducer,
  featureFlag: featureFlagReducer,
  forgotPassword: forgotPasswordReducer,
  header: headerReducer,
  myAccount: myAccountReducer,
  promoTools: promoToolsReducer,
  signup: signupReducer,
  setPassword: setPasswordReducer,
  mySites: mySitesReducer,
  sitebuilder: sitebuilderReducer,
  statistics: statisticsReducer,
  messages: messagesReducer,
  oneClick: oneClickReducer,
  unsavedChanges: unsavedChangesReducer,
  news: NewsReducer,
  report: reportTrackerReducer,
});

export default rootReducer;
